import { IonApp } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/typography.css";
import React from "react";

/* Global CSS */
import { AppStateProvider } from "./AppStateProvider";
import "./global.css";

/* Tailwind styles */
import "./theme/tailwind.css";

/* Theme variables */
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import { AppAnalyticsProvider } from "./AppAnalyticsProvider";
import { AppListenerProvider } from "./AppListenerProvider";
import AppMain from "./AppMain";
import AppRedirect from "./components/ComponentsFunctional/AppRedirect/AppRedirect";
import { SignUpProvider } from "./components/ComponentsOnboarding/SignUpProvider/SignUpProvider";
import { DeepLinkProvider } from "./DeepLinkProvider";
import "./theme/variables.css";
import { PhoneVerificationProvider } from "./PhoneVerificationProvider";
import { VolumeProvider } from "./VolumeProvider";

const queryClient = new QueryClient()

const App: React.FC = () => {
    return (
        <IonReactRouter>
            <QueryClientProvider client={queryClient}>
                <AppStateProvider>
                    <AppListenerProvider>
                        <AppAnalyticsProvider>
                            <DeepLinkProvider>
                                <SignUpProvider>
                                    <VolumeProvider>
                                        <PhoneVerificationProvider>
                                            <AppRedirect />
                                            <IonicApp />
                                        </PhoneVerificationProvider>
                                    </VolumeProvider>
                                </SignUpProvider>
                            </DeepLinkProvider>
                        </AppAnalyticsProvider>
                    </AppListenerProvider>
                </AppStateProvider>
            </QueryClientProvider>
        </IonReactRouter>
    );
};


const IonicApp: React.FC = () => {

    return (
        <IonApp>
            <AppMain />
        </IonApp>
    );
};

export default App;
